import { createContext, useState } from "react";


export const contextApi = createContext('')

var
    persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
    arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g],
    fixNumbers = function (str) {
        if (typeof str === 'string') {
            for (var i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    };
export default fixNumbers
export const ConfigProvider = (props) => {

    const [menu, setMenu] = useState(false)
    const [login, setLogin] = useState(false)
    const [load, setLoad] = useState(false)
    const [clicks, setClicks] = useState([]);

    const recordClick = (buttonName) => {
        setClicks([...clicks, buttonName]);
    };

    return (
        <contextApi.Provider
            value={
                {
                    menu: menu,
                    setMenu: setMenu,
                    login: login,
                    setLogin: setLogin,
                    setLoad: setLoad,
                    load: load,
                    clicks: clicks,
                   recordClick: recordClick,
                }}
        >
            {props.children}
        </contextApi.Provider>
    );

}